import { useEffect, useRef, useState } from "react";

export default function HeroVideo() {
  const ref = useRef(null);
  const [videoFailed, setVideoFailed] = useState(false);

  useEffect(() => {
    const v = ref.current;
    if (!v) return;

    const tryPlay = () => {
      v.play().catch(() => {
        // Autoplay failed (e.g. iOS Low Power Mode) → fallback to background
        setVideoFailed(true);
      });
    };

    tryPlay();

    // Retry when in view
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) v.play().catch(() => setVideoFailed(true));
      else v.pause();
    }, { threshold: 0.25 });
    io.observe(v);

    return () => io.disconnect();
  }, []);

  return (
    <div
      id="hero-video-wrapper"
      style={{
        position: "absolute",
        inset: 0,
        zIndex: -1,
        backgroundImage: videoFailed ? "url('../assets/lri3.jpg')" : "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {!videoFailed && (
        <video
          ref={ref}
          src="../assets/livingroomvid2.mp4"
          autoPlay
          muted
          playsInline
          loop
          preload="auto"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      )}
    </div>
  );
}
